import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { JEService } from 'src/app/services/je-services.service';

@Component({
  selector: 'app-farmer-app-change-request',
  templateUrl: './farmer-app-change-request.component.html',
  styleUrls: ['./farmer-app-change-request.component.scss']
})
export class FarmerAppChangeRequestComponent implements OnInit {

  changeReqApplications: any = [];
  payload: any;

  subjectSub: any;
  selectedYear: any;
  subscriptions: any = [];

  constructor(
    private messageService: MessageService,
    private cryptoJsService: CryptoJsService,
    private confirmationService: ConfirmationService, 
    private jeService: JEService, 
    private router: Router,
    private loader: AppLoaderService,
    private service: BaseService
  ) { }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    this.payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    // this.loadData();
    this.loadDataAndApplyFilter();
  }


  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {

        
        this.selectedYear = res;
        this.loadData();
        // this.miVerificationTable.filters['FinYear'] = [
        //   { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  loadData(){
    this.loader.start();
    this.jeService.getApplicationsForPhysicalVerification(JSON.parse(this.payload)?.sub, '', this.selectedYear)
    .pipe(first())
    .subscribe({
      next: (data) => {
        this.changeReqApplications = data;
        this.loader.close();
      },
      error: () => {
        this.loader.close();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Physical Applications not loaded.' });
      }
    });
  }

  selectPhysicalVerAppln(application: any) {
    if (application.AutoId) {
      let encryptedAutoId = this.cryptoJsService.Encrypt(application.AutoId.toString());
      let encryptedAppId = this.cryptoJsService.Encrypt(application.AppID.toString());
      this.router.navigate([this.router.url.split('/')[1], 'application'], { queryParams: { autoId: encryptedAutoId, appId: encryptedAppId } });
    }else{
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
    }

  }

  deletePhysicalVerAppln(application : any){

  }
  

}
